/*=========================================================================================
  File Name: moduleCompanyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import {createCompanyFilterPayload} from "@/store/payloadHelper.js";

export default {
	addItemCompany({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/company", item)
				.then((response) => {
					commit("ADD_COMPANY", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/company")
				.then((res) => {
					commit("SET_COMPANIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/company/${item.id}`, item)
				.then((response) => {
					commit("UPDATE_COMPANY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/company/${itemId}`)
				.then((response) => {
					commit("REMOVE_COMPANY", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getCompanyCost({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/company/costs/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getCompanyId({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/company/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchCompanyFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createCompanyFilterPayload(data);
			Api.post("/company/filter", payload)
				.then((res) => {
					commit("SET_COMPANIES", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
